import { Controller } from "stimulus";
import toastr from "toastr";
export default class extends Controller {
  static targets = ["span", "edit", "save", "input"];
  static values = { cid: Number, rcaid: Number };

  connect() {
    toastr.options = {
      progressBar: true,
      positionClass: "toast-top-center",
      preventDuplicates: true,
      timeOut: "3000",
    };
  }

  async changeValidity(event) {
    event.preventDefault();
    const input = this.inputTarget;
    const value = input.value;
    let url = `/courses/${this.cidValue}.json`;

    const payload = {
      course: {
        demo_course_validity: value,
      },
    };

    try {
      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });
      if (response.ok) {
        const span = this.spanTarget;
        const new_span = document.createElement("span");
        new_span.innerText = value;
        span.replaceChild(new_span, span.firstChild);
        this.editTarget.classList.remove("d-none");
        this.saveTarget.classList.add("d-none");
        toastr.success("Course Free Validity Changed Successfully !");
      } else {
        console.error("Error:", response.statusText);
        toastr.error("Error while Changing Validity !");
      }
    } catch (error) {
      console.error("Error trt:", error);
      toastr.error("Error while Changing Validity !");
    }
  }

  async changeRCAValidity(event) {
    event.preventDefault();
    const input = this.inputTarget;
    const value = input.value;
    let url = `/request_course_accesses/${this.rcaidValue}.json`;

    const payload = {
      request_course_access: {
        course_validity: value,
      },
    };

    try {
      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });
      if (response.ok) {
        const span = this.spanTarget;
        const new_span = document.createElement("span");
        new_span.innerText = value;
        span.replaceChild(new_span, span.firstChild);
        this.editTarget.classList.remove("d-none");
        this.saveTarget.classList.add("d-none");
        toastr.success("Request Course Validity Changed Successfully !");
      } else {
        console.error("Error:", response.statusText);
        toastr.error("Error while Changing Validity !");
      }
    } catch (error) {
      console.error("Error trt:", error);
      toastr.error("Error while Changing Validity !");
    }
  }

  showField() {
    const span = this.spanTarget;
    const input = document.createElement("input");
    input.type = "number";
    input.name = "course[demo_course_validity]";
    input.value = this.spanTarget.innerText;
    input.className = "form-control";
    input.setAttribute("data-free-access-target", "input");
    span.replaceChild(input, span.firstChild);
    input.focus();
    this.editTarget.classList.add("d-none");
    this.saveTarget.classList.remove("d-none");
  }
}
